<div class="c-page-pickup">
    <div class="container u-pb30">
        <div class="row mobile--orange u-pt40">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a [routerLink]="['/']" >{{'PickupPortal.home' | translate}} </a></li>
                        <li class="breadcrumb-item active" aria-current="page">&nbsp; - <span> {{'PickupPortal.location' | translate}}</span></li>
                    </ol>
                </nav>
                <h2 class="o-title">{{'PickupPortal.title' | translate}}</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="u-pt60" *ngFor=" let site of SitePickups; index as i">
                    <!--title-->
                    <h3 class="o-title o-title--medium o-title--orange">{{site.name}}</h3>
                    <!--item map-->
                    <div class="c-card c-card--maps" *ngFor=" let pickup of site.pickups; index as j">
                        <div class="row">
                            <div style="padding: 20px;">
                                <div class="col-md-4">
                                    <h4 class="o-title o-title--small" *ngIf="getlang()==='en'">{{pickup.name}}</h4>
                                    <h4 class="o-title o-title--small" *ngIf="getlang()==='es'">{{pickup.nameEs}}</h4>
                                </div>
                                <div class="col-md-6 c-card--maps-info">
                                    <p><strong>{{'PickupPortal.labelAdress' | translate}}:</strong><a>{{pickup.address}}</a></p>
                                    <p><strong>{{'PickupPortal.labelEmail' | translate}}:</strong><a>{{pickup.email}}</a></p>
                                    <p><strong>{{'PickupPortal.labelPhone' | translate}}:</strong><a>{{pickup.phone}}</a></p>
                                </div>
                                <div class="col-md-2 text-right"><a class="btn btn--primary" (click)="PushImage(i , j )">{{'PickupPortal.btnMap' | translate}}</a></div>
                            </div>
                            <div *ngIf="pickup.image && pickup.show"> <img style="width:100%" [src]="pickup.image"></div>

                        </div>
                    </div>

                </div>


            </div>

        </div>
    </div>